<!--
 * @Author: pengyong
 * @Date: 2020-11-10 15:00:22
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-11 22:30:42
 * @Description:
 * @FilePath: /exhibit/src/views/index/index.vue
-->
<template>
  <div class="index-wrapper">
    <PlayVideo />
  </div>
</template>

<script>
import PlayVideo from "./components/PlayVideo";
export default {
    components: {
        PlayVideo
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue